import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dependent"];

  update(event = undefined) {
    const dependentTargets = Array.from(this.dependentTargets).filter((x) =>
      event.params.dependents.includes(x.dataset.formDependenciesId),
    );

    const resetElements = new Set();

    for (const dependentTarget of dependentTargets) {
      let action = true;

      switch (dependentTarget.dataset.formDependenciesCondition) {
        case "any":
          action = false;
          break;
        case "checked":
          action = !event.target.checked;
          break;
        case "eq":
          action =
            event.target.value !==
            dependentTarget.dataset.formDependenciesValue;
          break;
        case "gt":
          action =
            parseInt(event.target.value) <=
            parseInt(dependentTarget.dataset.formDependenciesValue);
          break;
      }

      dependentTarget.hidden = action;
      dependentTarget.disabled = action;

      if (action) {
        if (dependentTarget.tagName == "OPTION") {
          resetElements.add(dependentTarget.parentElement);
        } else {
          resetElements.add(dependentTarget);
        }
      }

      for (const field of dependentTarget.querySelectorAll(
        "input,select,textarea",
      )) {
        field.disabled = action;
      }
    }

    for (const resetElement of resetElements) {
      let eventName = "input";
      if (resetElement.tagName === "SELECT") eventName = "change";

      resetElement.value = "";
      resetElement.dispatchEvent(new Event(eventName, { bubbles: true }));
    }
  }
}
